import { useQuery, useQueryClient } from "@tanstack/react-query";
import * as inviteRecipientApi from "@/lib/api/flow-instances/invite-recipient";

export const inviteRecipientKeys = {
  value: (instanceId: string | null) => ["flowInstances", instanceId, "invite-recipient"] as const,
};

/**
 * QL-505 follow-up — who the Invite Client dialog sends to right now (client /
 * representative-only / members). Invalidated by every mutation that can flip
 * it: issuing/revoking/sending a member link, generating/revoking the group's
 * public access, and (via the broad `["flowInstances"]` invalidation in
 * `useClientGroupMembers`/`useClientParties`) any group-membership or party
 * change.
 */
export function useInviteRecipient(instanceId: string | null) {
  const { data, error, isLoading } = useQuery({
    queryKey: inviteRecipientKeys.value(instanceId),
    queryFn: () => inviteRecipientApi.getInviteRecipient(instanceId!),
    enabled: !!instanceId,
  });
  const queryClient = useQueryClient();
  const mutate = () =>
    queryClient.invalidateQueries({ queryKey: inviteRecipientKeys.value(instanceId) });
  return { recipient: data ?? null, error, isLoading, mutate };
}
